import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import CONFIG from '../config/config';
import { Box, Typography, Card, CardContent, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from '@mui/material';

const toPascalCase = (str) => {
    if (!str) return '';
    return str
        .toLowerCase()
        .split(/[\s-_]/) // Split by space, hyphen, or underscore
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
};

const Pricing = () => {
    const navigate = useNavigate();

    const handleSignup = (plan) => {
        if (plan === 'Free' || plan === 'Pro') {
            navigate('/signup', { state: { selectedPlan: plan } });
        } else {
            alert('This plan is coming soon!');
        }
    };

    const pricingPlans = [
        {
            title: toPascalCase(CONFIG.PLAN_IDS.FREE),
            price: '–',
            description: 'Perfect for individual pilots starting out.',
            features: ['1', '2', '3', '4', '5'],
            buttonText: 'Get Started',
            buttonVariant: 'contained',
            details: ['Unlimited Non-pilots', 'One Pilot ¹'],
            footnote: 'An Instapath Pilot Pro subscription is recommended for each pilot.',
        },
        {
            title: toPascalCase(CONFIG.PLAN_IDS.PRO),
            price: '–', // '$39.99/yr ¹'
            description: 'Enhanced funtionality in our mobile app.', //Enhanced functionality and access to premium features
            features: ['1', '2', '3', '4', '5', '10', '11', '12'],
            buttonText: 'Get Started',
            buttonVariant: 'contained',
            details: ['Unlimited Non-pilots', 'One Pilot ¹'],
            footnote: 'Requires an Instapath Pilot Pro mobile app subscription.',
        },
        /*{
            title: toPascalCase(CONFIG.PLAN_IDS.BUSINESS),
            price: '$15/mo/seat',
            description: 'For teams seeking powerful tools and scalability.',
            features: ['1', '2', '3', '4', '5', '6', '7', '10', '11', '20', '21', '22', '23', '24', '25', '26', '27'],
            buttonText: 'Coming Soon',
            buttonVariant: 'contained',
            details: ['One Organization', 'Unlimited Non-pilots', 'One Pilot ¹'], // 'One Seat Per Pilot ¹'
            footnote: 'An Instapath Pilot Pro subscription is recommended for each pilot.',
            isRecommended: true,
        },*/
        /*{
            title: toPascalCase(CONFIG.PLAN_IDS.ENTERPRISE),
            price: '$100/mo/seat',
            description: 'Advanced solutions tailored for teams operating at scale.',
            features: ['1', '2', '3', '4', '5', '6', '7', '10', '11', '20', '21', '22', '23', '24', '25', '26', '27', '30', '31', '32', '33', '34', '35'],
            buttonText: 'Coming Soon',
            buttonVariant: 'contained',
            details: ['One Organization', 'Unlimited Non-pilots', 'One Pilot ¹'],
            footnote: 'An Instapath Pilot Pro subscription is recommended for each pilot.',
        },*/
    ];

    const allFeatures = [
        // Free
        { key: '1', title: 'One Pilot', subtitle: 'Assign one remote Pilot in Command (PIC) to each organization for mission management.' },
        { key: '2', title: 'Unlimited non-pilots', subtitle: 'Manage an unlimited number of non-PIC personnel within each organization.' },
        { key: '3', title: 'Unlimited flights', subtitle: 'Create as many missions as you need without any limits.' },
        { key: '4', title: 'Mobile app sync', subtitle: 'Sync your data seamlessly with the Instapath mobile app in real-time.' },
        { key: '5', title: 'Mission planning', subtitle: 'Plan your flight with ease, including location, schedule, and assigned PIC.' },
        //{ key: '7', title: 'Basic checklists', subtitle: 'Utilize pre-built checklists for essential mission planning and execution.' },

        // Pro
        { key: '10', title: 'Manage multiple organizations', subtitle: 'Manage multiple organizations within the Instapath platform—all from a single account.' },
        { key: '11', title: 'Custom reporting', subtitle: 'Generate detailed reports for missions, pilots, and more.' },
        { key: '12', title: 'Post-flight actions', subtitle: 'Complete post-flight tasks like pilot debriefs, adding maintenance notes, and editing flight times.' },

        /*
        // Business
        { key: '21', title: 'Shot lists', subtitle: '' },
        { key: '22', title: 'Crew members', subtitle: 'Assign crew members to missions' },
        { key: '23', title: 'Assets', subtitle: 'Mananage aircraft and batteries, assign aircraft to missions.' },
        { key: '24', title: 'Flight logs', subtitle: 'Upload and import' },
        { key: '25', title: 'Advanced Personnel Profiling', subtitle: 'Personnel certifications, Approved Drone models, Skills and capabilities (Regulations, Operations, Business solutions and tools). Pre-defined skills and possibility to add custom ones.' },
Add Validation rule to a checklist template and check easily fill status and validation score for each mission checklists.' },
        { key: '26', title: 'Mission Request', subtitle: 'Allowed external person can access a PIN protected form to request new mission.' },
        { key: '27', title: 'Customer Management', subtitle: 'Manage your customers and their projects. Mass-import your existing customers database.' },

        // Enterprise
        { key: '30', title: 'Drone Inspections Schedules', subtitle: 'Define your drone inspection plans, for each drone parts. Track Part Serial number, lifespan and replacement history.' },
        { key: '31', title: 'Maintenance', subtitle: '' },
        { key: '32', title: 'Incidents', subtitle: '' },
        { key: '33', title: 'Operations Calendar', subtitle: 'View all your operations (flights and planned missions) on a calendar view: year, month, week, day.' },
        { key: '34', title: 'Unlimited remote PICs', subtitle: 'Add one or more remote PICs to each organization.' },
        { key: '35', title: 'Custom Checklists', subtitle: 'Create custom digital forms, and attach them to a flight, mission, project, drone, ...etc.         
*/

        //{ key: '4', title: 'Flight Log Upload and Import', subtitle: 'More than 70 log formats supported (manufacturers and third-party apps): DJI, Autel, Parrot, Yuneec, Wingtra, MikroKopter, MapsMadeEasy, DroneDeploy,...etc.' },
        //{ key: '1', title: 'Manage Flight Data', subtitle: 'Flight, drone, equipment, battery, location, incident, maintenances, documents.' },
        //{ key: '3', title: 'Unlimited Flights and Documents', subtitle: 'Description of Feature 2.' },
        //{ key: '3', title: 'Draw Flight Areas and Check Airspace Safety Status', subtitle: 'Dynamic controlled airspace safety info when drawing your flight areas.' },
        //{ key: '7', title: '3D View Replay and Flight Track Export', subtitle: 'Replay your flight in beautiful 3D view. Export your flight track as Google Earth (KML) and IGC format.' },
        //{ key: '8', title: 'DJI Go App Sync', subtitle: 'Sync and import automatically your DJI saved flights.' },
        //{ key: '9', title: 'Automatic Flight Data Logging', subtitle: 'Flight data are pushed directly to your logbook, from Parrot Anafi, Sensefly, Yuneec, Watts, DroneHarmony, MapsMadeEasy, DroneLink, Sky-Drones, UgCS, SimNet,...' },
        //{ key: '10', title: 'DJI Battery Health', subtitle: 'Display battery information over the time from imported flight log. Data tracked are Battery Life, initial capacity , max temperature, efficiency.' },
        //{ key: '13', title: 'Data Export', subtitle: 'Flights, Equipment, Battery, Incident and Pilot 90 days currency (CSV format).' },
        //{ key: '14', title: 'Compliance Reporting', subtitle: 'FAA, CAA, CASA, CAD, DGAC...etc' },
        //{ key: '16', title: 'Mission Planning', subtitle: 'Prepare your flight and all necessary documents. Draw flight areas and check airspace safety status.' },
        //{ key: '19', title: 'API Data Access', subtitle: 'Access your data programmatically using our API.' },
        //{ key: '20', title: 'Large Telemetry Log Flight Import', subtitle: 'Ability to upload and import large telemetry log flight (>1Go).' },
        //{ key: '21', title: 'Preflight Forms', subtitle: 'Risk Assessment, Photograph & Video Release, Authorization from Property Representative, Plan of activity.' },
        //{ key: '23', title: 'Custom Forms & Checklist Validation Rule', subtitle: 'Create custom digital forms, and attach them to a flight, mission, project, drone, ...etc. Add Validation rule to a checklist template and check easily fill status and validation score for each mission checklists.' },
        //{ key: '24', title: 'Mission Detail and Ops Calendar Sharing', subtitle: 'Share Mission detail and Ops Calendar with external person via a PIN Code protected link.Flight and Mission detail information' },
        //{ key: '26', title: 'Custom Report Template Engine', subtitle: 'Create custom report layouts, by drag-dropping dataset snippets and generates PDF/CSV reports from them.' },
        //{ key: '27', title: 'Audit Trail', subtitle: 'Audit trail on all data, cross multi-organizations.' },
        //{ key: '28', title: 'Notifications', subtitle: 'Multiple notifications like: Flight at night detection, Document expiration, Low Pilot currency,...etc.' },
        //{ key: '30', title: 'Own Branding', subtitle: '' },
        //{ key: '31', title: 'Notification Messaging', subtitle: 'Send notifications to personnel in your org or across multiple orgs; and define auto-notication template for triggers like Pilot document expiration, overdue mission, drone inspection overdue, Drone part replacement overdue,...etc' },
        //{ key: '32', title: 'Drone Profile', subtitle: 'Create a drone profile, related to a Brand / Model and used to preset a new added drone with default values (geometry, type, weight...) and scheduled inspections configuration.' },
    ];

    const planIncludesFeature = (plan, feature) =>
        pricingPlans.find((p) => p.title === plan)?.features.includes(feature);

    return (
        <>
            {/* Account for header height */}
            <Box sx={{ padding: '16px 16px 16px', backgroundColor: '#f9f9f9' }}>
                <Typography variant="h3" align="center" gutterBottom>
                    Pricing Plans
                </Typography>
                <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
                    Choose the plan that works best for you and your team.
                </Typography>

                {/* Pricing Cards */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center', // space-between
                        flexWrap: 'nowrap', // Prevent wrapping to a new row
                        gap: 2,
                        padding: 4,
                        overflowX: 'auto', // Allow horizontal scrolling if necessary
                    }}
                >
                    {pricingPlans.map((plan, index) => (
                        <Box
                            key={index}
                            sx={{
                                flex: '1 1 calc(25% - 16px)', // Each card takes 25% width minus spacing
                                maxWidth: 'calc(25% - 16px)', // Ensure max width aligns with flex-basis
                                minWidth: '250px', // Ensure cards don’t shrink below 250px
                                margin: '0 8px', // Add horizontal spacing
                                position: 'relative',
                            }}
                        >
                            {plan.isRecommended && (
                                <Chip
                                    label="Most Popular"
                                    sx={{
                                        position: 'absolute',
                                        top: '-16px', // Adjust to ensure it appears above the card
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: '#42a5f5',
                                        color: '#fff',
                                        fontWeight: 600,
                                        zIndex: 2, // Ensure it appears above other elements
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Optional shadow for emphasis
                                    }}
                                />
                            )}
                            <Card
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    boxShadow: 2,
                                    border: plan.isRecommended ? '2px solid #42a5f5' : 'none',
                                }}
                            >
                                <CardContent
                                    sx={{
                                        paddingTop: plan.isRecommended ? '32px' : '34px',
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        component="div"
                                        gutterBottom
                                        sx={{
                                            color: '#34495e',
                                            fontWeight: 400,
                                        }}
                                    >
                                        {plan.title}
                                    </Typography>
                                    <Typography variant="body2" color="#6c757d" paragraph>
                                        {plan.description}
                                    </Typography>
                                    <Typography variant="h5" color="#2c3e50" gutterBottom>
                                        {plan.price}
                                    </Typography>

                                    {/* Render Plan Details */}
                                    <Box sx={{ marginTop: 2, color: '#6c757d' }}>
                                        {plan.details.map((detail, i) => (
                                            <Typography key={i} variant="body2">
                                                {detail}
                                            </Typography>
                                        ))}
                                    </Box>
                                    <Button
                                        variant={plan.buttonVariant}
                                        color="primary"
                                        sx={{ marginTop: 3 }}
                                        onClick={() => handleSignup(plan.title)}
                                    >
                                        {plan.buttonText}
                                    </Button>

                                    {/* Render Footnote */}
                                    {plan.footnote && (
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                marginTop: 2,
                                                display: 'block',
                                                color: '#6c757d',
                                                fontSize: '0.65rem',
                                            }}
                                        >
                                            ¹ {plan.footnote.includes('Instapath Pilot Pro') ? (
                                                <>
                                                    {plan.footnote.split('Instapath Pilot Pro')[0]}
                                                    <Link to="/instapath-pilot" style={{ color: '#42a5f5', textDecoration: 'none' }}>
                                                        Instapath Pilot Pro
                                                    </Link>
                                                    {plan.footnote.split('Instapath Pilot Pro')[1]}
                                                </>
                                            ) : (
                                                plan.footnote
                                            )}
                                        </Typography>
                                    )}


                                </CardContent>
                            </Card>
                        </Box>
                    ))}
                </Box>

                {/* Features Comparison Table */}
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '1090px', // Constrain the table width
                        margin: '0 auto',   // Center the table horizontally
                        overflowX: 'auto',  // Enable horizontal scrolling if content overflows
                    }}
                >
                    <TableContainer component={Paper}>
                        <Table sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
                            <TableHead>
                                <TableRow>
                                    {/* First column: Flexible width */}
                                    <TableCell
                                        sx={{
                                            minWidth: '180px',
                                            fontWeight: 'bold',
                                            color: '#2c3e50',
                                            backgroundColor: '#e9ecef', // Gray bar for header
                                        }}
                                    >
                                        Features
                                    </TableCell>

                                    {/* Pricing columns */}
                                    {pricingPlans.map((plan, index) => (
                                        <TableCell
                                            key={index}
                                            align="center"
                                            sx={{
                                                width: '80px',
                                                fontWeight: 'bold',
                                                color: '#2c3e50',
                                                backgroundColor: '#e9ecef', // Gray bar for header
                                            }}
                                        >
                                            {plan.title}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allFeatures.map((feature, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            '&:nth-of-type(odd)': { backgroundColor: '#f8f9fa' },
                                        }}
                                    >
                                        {/* Feature title and subtitle */}
                                        <TableCell
                                            sx={{
                                                minWidth: '180px',
                                                fontWeight: 400,
                                                color: '#2c3e50',
                                            }}
                                        >
                                            <strong>{feature.title}</strong>
                                            <Typography
                                                variant="body2"
                                                sx={{ color: '#6c757d', fontSize: '12px', marginTop: '4px' }}
                                            >
                                                {feature.subtitle}
                                            </Typography>
                                        </TableCell>

                                        {/* Pricing columns */}
                                        {pricingPlans.map((plan, planIndex) => (
                                            <TableCell
                                                key={planIndex}
                                                align="center"
                                                sx={{
                                                    width: '80px',
                                                    color: '#2c3e50',
                                                }}
                                            >
                                                {plan.features.includes(feature.key) ? '✔️' : '-'} {/* ❌ */}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </>
    );
};

export default Pricing;